import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import am4lang_de_CH from "@amcharts/amcharts4/lang/de_CH";
import { EvuDefaultStyles } from '../../scss/_base-styles';

export namespace LandingPage {

    export function initGlobals() {
        am4core.options.queue = false;
        am4core.options.onlyShowOnViewport = false;
        am4core.useTheme(am4themes_animated);
        am4core.useTheme(am4themes_material);
    }

    function createAmChartV4(options: any) {
        let chart = am4core.create(document.getElementById(options.canvas), am4charts.XYChart);

        //chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.backgroundColor = am4core.color("#fff", 0);

        chart.language.locale = am4lang_de_CH;
        chart.dateFormatter.dateFormat = "dd.MM.yyyy";

        chart.data = options.chartData;

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;

        dateAxis.dateFormats.setKey("month", "MMM yyyy");
        dateAxis.fontSize = options.axisFontSize;
        dateAxis.startLocation = 0.5;
        dateAxis.endLocation = 0.5;
        dateAxis.renderer.labels.template.fill = am4core.color(options.axisColor);
        dateAxis.renderer.grid.template.strokeWidth = 0;

// ** chart title labels
        let topContainer = chart.chartContainer.createChild(am4core.Container);
        topContainer.layout = "vertical";
        topContainer.toBack();
        topContainer.paddingBottom = 15;
        topContainer.width = am4core.percent(100);

        let axisTitle = topContainer.createChild(am4core.Label);
        axisTitle.text = options.title;
        axisTitle.fontFamily = "Lexend"
        axisTitle.fontWeight = "800";
        axisTitle.fontSize = 18;
        axisTitle.align = "left";
        axisTitle.dx = 50;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.minWidth = 35;
        valueAxis.fontSize = options.axisFontSize;
        valueAxis.renderer.labels.template.fill = am4core.color(options.axisColor);
        valueAxis.renderer.grid.template.strokeDasharray = "4,4";
        valueAxis.renderer.grid.template.strokeWidth = 1;

        var i = 0;
        for (let key in options.chartData[0]) {
            if (options.chartData[0].hasOwnProperty(key) && key != "date") {
                var series = chart.series.push(new am4charts.LineSeries());
                series.dataFields.dateX = "date";
                series.dataFields.valueY = key;
                series.name = series.dataFields.valueY;
                series.stroke = am4core.color(options.colors[i]);
                series.fill = series.stroke;
                series.strokeWidth = 2;
                series.strokeLinejoin = "round";
                i++;
            }

        }

        var legend = chart.legend = new am4charts.Legend();
        legend.position = "bottom";
        legend.fontSize = options.axisFontSize;
        legend.fontWeight = "bold";
        legend.useDefaultMarker = true;
        let marker = legend.markers.template.children.getIndex(0);
        marker.width = 20;
        marker.height = 20;
        (marker as any).cornerRadius(10, 10, 10, 10);

        return chart;
    }

    //Line Charts
    export function draw(canvas: any, colors: any, mainColor:string, axisFontSize:number) {
        //chartJahresProdukte
        return fetch("/data/GetJahresProdukteData").then(response => response.json()).then(data => {

            if (data.length === 0) return;

            return createAmChartV4({
                colors: colors,
                canvas: canvas,
                chartData: data,
                digits: null,
                title: 'Jahresprodukte Base Schweiz',
                mainColor: mainColor,
                axisFontSize: axisFontSize,
                axisColor: EvuDefaultStyles.colors.gray4
            });

        });
    }

    
}
